<!-- 作业评阅 -->
<template>
  <div class="el-ErrorSet">
    <el-row class="content_block">
      <TitleInfo title="作业评阅" :titleImg="zjie"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-col :span="6">
          <el-row style="overflow: auto;border: 1px solid #DEDEDE;margin-right: 20px;min-height:400px;height: calc(100vh - 220px);padding: 20px;">
            <el-form ref="form" :model="search1" label-width="80px">
              <el-form-item label="选择班级">
                <el-select clearable v-model="search1.schoolClassId" style="width: 100%;" placeholder="请选择班级">
                  <template v-for="(item ,index) in classList">
                    <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-input placeholder="请输入学号或姓名" style="width: calc(100% - 96px)" prefix-icon="el-icon-search" v-model="search1.studentOrName"></el-input>
              <el-button type="primary" icon="el-icon-search" @click="getStu(page_stu = 1)">搜索</el-button>
            </el-form>
            <el-table
              :data="stuData"
              border
              @row-click="tableRowClick"
              :row-class-name="tableRowClassName"
              style="width: 100%;margin-top: 10px;">
              <el-table-column prop="studentName" header-align="center" align="center" label="姓名">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentSn}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="sumScore" header-align="center" align="center" label="得分">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.sumStudentScore}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;margin-top: 20px;">
              <el-pagination
                @size-change="handleSizeChange_stu"
                @current-change="handleCurrentChange_stu"
                :current-page.sync="page_stu"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="limit_stu"
                background
                small
                :pager-count="5"
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next"
                :total="total_stu">
              </el-pagination>
            </div>
          </el-row>
        </el-col>
        <el-col :span="13">
          <el-row :class="($isEmpty(reportFile)?'onViewInfo':'')+' viewInfo'">
            <template v-if="!$isEmpty(reportFile)">
              <lookPdf :pdfUrl="$isHttp(reportFile)"></lookPdf>
              <!-- <iframe id="InformationURL" :src='$viewUrlInfo(reportFile)' width='100%' height='100%' frameborder='1'></iframe> -->
            </template>
            <template>
              <el-empty description="学生未上传报告"></el-empty>
            </template>
          </el-row>
        </el-col>
        <el-col :span="5">
          <el-row>
            <label>评分（满分100分）</label>
            <p>
              <el-input v-model="reviewInfo.score" type="number" placeholder="请输入分数"></el-input>
            </p>
            <p>
              <el-input v-model="reviewInfo.reply" type="textarea" :rows="12" placeholder="请输入评语"></el-input>
            </p>
          </el-row>
          <el-row>
            <el-button type="danger" :disabled="$isEmpty(this.reportFile)" @click="$downLoadFile(reportFile,fileName)">下载报告</el-button>
            <el-button type="primary" :disabled="$isEmpty(this.reportFile)" style="float: right;" @click="submitInfo" :loading="submitLoad">提交</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import {getClassInfo,getStudentScoreList} from "@/common/getInfo";	//加载数据
import lookPdf from "@/components/lookPdf"; //引入PDF查看器
export default {
  name: "ErrorSet",
  components: {
  	TitleInfo,
    lookPdf
  },
  data() {
    return {
      zjie:require("../../images/course/zjie@2x.png"),
      search1:{
        schoolClassId:"",
        studentOrName:""
      },
      stuData:[],
      total_stu: 0,
      limit_stu:10,
      page_stu:1,
      reviewInfo:{score:"",reply:""},
      seeStudentId:"",
      teacherOpenCourseQuestionLogIds:"",
      classList:[],
      teacherOpenCourseId:this.$route.query.courseId,
      teacherOpenCourseQuestionSettingId:this.$route.query.id,
      reportFile:"",
      fileName:"",
      onNum:0,
      submitLoad:false
    };
  },
  created() {
    getClassInfo({teacherOpenCourseId:this.teacherOpenCourseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
      }
    });
    this.getStu();
  },
  mounted() {

  },
  methods: {
    handleSizeChange_stu(val) {
      console.log(`每页 ${val} 条`);
      this.limit_stu = val;
      this.getStu();
    },
    handleCurrentChange_stu(val) {
      console.log(`当前页: ${val}`);
      this.page_stu = val;
      this.getStu();
    },
    getInfo(){ //获取列表
      let param = {
        studentId:this.seeStudentId,
        teacherOpenCourseId:this.teacherOpenCourseId,
        teacherOpenCourseQuestionSettingId:this.teacherOpenCourseQuestionSettingId
      }
      this.$get("/api/teacherOpenCourseQuestionLog/getFileQuestionLog.do",param).then((ret) =>{
        if(ret.code == 0){
          //this.reportFile = this.$viewUrlInfo("http://www.905.cn/server/filesystem/temp/金融工程/ppt/金融工程-P1-现金流的时间价值.pptx")
          if(!this.$isEmpty(ret.data) && !this.$isEmpty(ret.data.reportFile)){
            let reportFileInfo = JSON.parse(ret.data.reportFile);
            this.reportFile = reportFileInfo[0].fileUrl;
            this.fileName = reportFileInfo[0].fileName;
            this.reviewInfo.score = ret.data.reportScore;
            this.reviewInfo.reply = ret.data.reportComment;
          }else{
            let reportFileInfo = null;
            this.reportFile = null;
            this.fileName = null;
            this.reviewInfo.score = null;
            this.reviewInfo.reply = null;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getStu(){ //获取学生信息
      let param = {
        limit:this.limit_stu,
        page:this.page_stu,
        studentOrName:this.search1.studentOrName,
        classId:this.search1.classId,
        teacherOpenCourseQuestionSettingId:this.teacherOpenCourseQuestionSettingId,
        questionSettingType:'HOMEWORK_FILE'
      }
      this.param = Object.assign(param,this.search1);
      this.param['teacherOpenCourseQuestionLogStatus'] = 1;
      getStudentScoreList(param).then((ret) => {
        this.total_stu = Number(ret.count);
        this.stuData = ret.data;
        if(ret.data.length > 0){
          this.seeStudentId = ret.data[0].studentId;
          this.onNum = 0;
          this.teacherOpenCourseQuestionLogIds = ret.data[0].teacherOpenCourseQuestionLogId;
          this.getInfo();
        }
      });
    },
    refresh(){
      this.page = 1;
      this.seeStudentId = "";
      this.teacherOpenCourseQuestionLogIds = "";
      this.getInfo();
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    tableRowClick(ow, column, cell, event){
      this.onNum = ow.index;
      this.seeStudentId = ow.studentId;
      this.teacherOpenCourseQuestionLogIds = ow.teacherOpenCourseQuestionLogId;
      this.getInfo();
    },
    submitInfo(){ //提交评阅
      if(this.$isEmpty(this.reviewInfo.score)){
        this.$message.warning("请输入分值！");
        return;
      }
      if(100  < Number(this.reviewInfo.score)){
        this.$message.warning("输入的分值不能大于满分！");
        return;
      }
      this.submitLoad = true;
      this.reviewInfo.teacherOpenCourseQuestionLogIds = this.teacherOpenCourseQuestionLogIds;
      this.reviewInfo.teacherOpenCourseId = this.teacherOpenCourseId;
      this.reviewInfo.questionSettingId = this.teacherOpenCourseQuestionSettingId;
      this.reviewInfo.studentId = this.seeStudentId;
      this.reviewInfo.questionSettingType = "HOMEWORK_FILE";
      // if(!this.$isEmpty(this.reviewInfo.reply)){
      //   this.$message.warning("请输入评语！");
      //   return;
      // }
      this.$post("/api/teacherOpenCourseQuestionLog/manualModifyQuestionScores2.do",this.reviewInfo).then((ret) =>{
        this.submitLoad = false;
        if(ret.code == 0){
          this.$message({type: 'success',message: '提交成功！'});
          this.stuData[this.onNum].sumStudentScore = this.reviewInfo.score;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      }).catch(() => {
        this.submitLoad = false;
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-ErrorSet{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    .viewInfo{
      margin-right: 20px;min-height:400px;height: calc(100vh - 220px);
    }
    .onViewInfo{
      // background-color: #DEDEDE;
      border:1px solid #DEDEDE;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    input[type="number"] {
        -moz-appearance: textfield;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/HomeworkPracticalReview.vue